export const useProgressiveImage = (src: string): string => {
    const img = new Image()
    img.src = src
    img.onload = () => src
    return img.src
}
